const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const rowsToBoxes = rows =>
  rows.map(r => ({
    id: r.id,
    page: r.page,
    x: r.x,
    y: r.y,
    w: r.w,
    h: r.h,
    reason: r.reason ?? '',
    origin: r.detector === 'manual' ? 'manual' : 'ai',
    ...(r.text ? { text: r.text } : {})
  }))

export const boxesToRows = boxes =>
  boxes.map(({ id, page, x, y, w, h, reason }) => ({
    ...(UUID.test(id ?? '') ? { id } : {}),
    page,
    x,
    y,
    w,
    h,
    reason: reason ?? ''
  }))
